// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"2b45c925","318":"5d58f600","378":"51d2031c","423":"81846d71","511":"c8fa373d","612":"a5693d78","616":"a3c25da8"}[chunkId] + ".chunk.js";
};